import { render } from "./CustomerLotsView.vue?vue&type=template&id=01fc09c8&scoped=true&ts=true&lang=pug"
import script from "./CustomerLotsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerLotsView.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerLotsView.vue?vue&type=style&index=0&id=01fc09c8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fc09c8"]])

export default __exports__